<script setup lang="ts">
import { computed } from 'vue'
import SourceButton from '~/components/ui/SourceButton.vue'
import SourcePopin from '~/components/ui/SourcePopin.vue'

type Variant = 'danger' | 'warning' | 'info'

type Props = {
  show: boolean
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  variant?: Variant
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Confirmation',
  description: 'Êtes-vous sûr ?',
  confirmText: 'Confirmer',
  cancelText: 'Annuler',
  variant: 'warning',
  loading: false,
})

const emit = defineEmits<{
  (e: 'close' | 'confirm'): void
}>()

const isOpen = computed({
  get: () => props.show,
  set: (value: boolean) => {
    if (!value) emit('close')
  },
})

const cancelButtonType = computed(() => {
  if (props.variant === 'danger') return 'deleteSecondary' as const
  return 'secondary' as const
})

const confirmButtonType = computed(() => {
  if (props.variant === 'info') return 'primary' as const
  return 'deletePrimary' as const
})

function onClose(): void {
  if (props.loading) return
  emit('close')
}

function onConfirm(): void {
  if (props.loading) return
  emit('confirm')
}
</script>

<template>
  <SourcePopin
    v-model:open="isOpen"
    :title="title"
    :description="description"
    size="small"
    :has-clear="true"
    :close-on-backdrop="!loading"
    :close-on-escape="!loading"
    @close="onClose"
  >
    <template #actions>
      <SourceButton
        :text="cancelText"
        :type="cancelButtonType"
        size="small"
        :disabled="loading"
        @click="onClose"
      />
      <SourceButton
        :text="confirmText"
        :type="confirmButtonType"
        size="small"
        :disabled="loading"
        @click="onConfirm"
      />
    </template>
  </SourcePopin>
</template>
